// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"351":"e07c2e81","453":"0641acc3","455":"c8bcdf15","977":"27c4769e"}[chunkId] + ".chunk.js";
};